import { render, staticRenderFns } from "./VisitPayment.vue?vue&type=template&id=28cb91b6&"
import script from "./VisitPayment.vue?vue&type=script&lang=js&"
export * from "./VisitPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports